import './SideMenu.scss';

import classNames from 'classnames';
import { observer } from 'mobx-react';

import { ONBOARDING_CONFIG } from '../../features/onboarding/constants';
import { useHiddenBodyOverflow } from '../../hooks/useHiddenBodyOverflow';
import { useSideMenu } from '../../hooks/useSideMenu';
import { useFlag } from '../../services/launchDarkly';
import { useStores } from '../../stores/useStores';
import { ChangeLanguage } from '../ChangeLanguage/ChangeLanguage';

import { SideMenuContent } from './SideMenuContent';

const SideMenu = observer(() => {
  const { uiStore, onboardingStore } = useStores();

  const isLanguageChangeAvailable = useFlag('language_change_available', false);

  const { handleClose } = useSideMenu();

  useHiddenBodyOverflow(uiStore.sideMenuOpen);

  const showOnboarding = ONBOARDING_CONFIG.MENU_ACTIONS.has(onboardingStore.step);

  return (
    <div className="side-menu-wrapper">
      <div
        className={classNames('menu-overlay', { 'menu-overlay_opened': uiStore.sideMenuOpen })}
        onClick={handleClose}
      ></div>
      <div
        className={classNames('side-menu', {
          'side-menu_opened': uiStore.sideMenuOpen,
          'side-menu_onboarding': showOnboarding,
        })}
      >
        {isLanguageChangeAvailable && (
          <div className="side-menu-language">
            <ChangeLanguage showTitlePrefixIcon />
          </div>
        )}
        <button className="side-menu__close" onClick={handleClose}>
          &times;
        </button>
        <SideMenuContent />
      </div>
    </div>
  );
});

export default SideMenu;
